import React from 'react';
import { motion } from 'framer-motion';
declare global {
  interface Window {
    fbq: any;
  }
}
interface CTAButtonProps {
  href?: string;
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  href = 'https://coresolutionsg.com/cart/47499543904443:1',
  children,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Academia de Velas Aromáticas',
        content_type: 'product',
        value: 17.0,
        currency: 'USD'
      });
    }
  };
  return <motion.a href={href} onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-gradient-to-r from-brand-ctaStart to-brand-ctaEnd rounded-full shadow-lg hover:shadow-xl transition-shadow duration-300 ${className}`} data-id="element-11">
      {children}
    </motion.a>;
}